// extracted by mini-css-extract-plugin
module.exports = {"Delete":"ResourceForm_Delete__22-F9"};